import { ICard, ICardConfig, ITile, IUrlTile, CardType } from '../models/i-card';
import { TranslateService } from '@ngx-translate/core';

const getFocusCardConfig = (card: ICard, translate: TranslateService): ICardConfig => ({
  focusButtonTitle: translate.instant('cards.focusInsight'),
  indicatorClass: 'focus',
  type: CardType.focusCard,
  showButton: false,
});

const getAnalyticsCardReportConfig = (translate: TranslateService): ICardConfig => ({
  focusButtonTitle: translate.instant('cards.viewReport'),
  linkTitle: translate.instant('cards.viewInAnalytics'),
  indicatorClass: 'analytics',
  type: CardType.report,
  showButton: true,
});

export const getAnalyticsCardTableAUConfig = (translate: TranslateService): ICardConfig => ({
  focusButtonTitle: translate.instant('cards.viewReport'),
  linkTitle: translate.instant('cards.viewInAnalytics'),
  indicatorClass: 'analytics',
  type: CardType.tableau,
  showButton: true,
});

export const getAnalyticsCardMapConfig = (translate: TranslateService): ICardConfig => ({
  focusButtonTitle: translate.instant('cards.viewMap'),
  indicatorClass: 'analytics',
  type: CardType.map,
  showButton: true,
});

// TODO: update during profile integration
const getProfilesCardConfig = (_card: ICard, _translate: TranslateService): ICardConfig => ({
  focusButtonTitle: '',
  indicatorClass: 'profiles',
  type: CardType.map,
  showButton: true,
});

export const getWorkCardConfig = (card: ICard, translate: TranslateService): ICardConfig => {
  // TODO: for testing purposes
  const testUrl = window['testDecisionNavigationUrl']

  let config: ICardConfig = {
    focusButtonTitle: translate.instant('cards.startWorkflow'),
    indicatorClass: 'work',
    type: CardType.work,
    showInNewTab: false,
    showButton: true,
  };
  
  card?.rows?.find((r) =>
    r.tiles.find((t: ITile) => {
      // check only IURL tile
      if (t.cardTileTypeID === 8) {
        const data: IUrlTile = t.data as IUrlTile;
        let _config = data.config;

        if(testUrl) { // OWERIDE URL for testing purposes
          _config = { ...data.config, url: testUrl};
        }

        const showInNewTab = _config.url.toLowerCase().includes('opennewtab=true')

        config = { ...config, config: _config, showInNewTab };

        return;
      }
    })
  );

  return config;
};

export const getAnalyticsCardConfig = (card: ICard, translate: TranslateService): ICardConfig => {
  let config = getAnalyticsCardReportConfig(translate);
  card?.rows?.find((r) =>
    r.tiles.find((t: ITile) => {
      // check only IURL tile
      if (t.cardTileTypeID === 8) {
        const data: IUrlTile = t.data as IUrlTile;

        switch (data?.config?.reportType.toLowerCase()) {
        case 'covidmap': {
          config = getAnalyticsCardMapConfig(translate);
          break;
        }
        case 'externallink': {
          config = { ...getAnalyticsCardTableAUConfig(translate), config: data.config };
          break;
        }
        default: {
          config = getAnalyticsCardReportConfig(translate);
        }
        }

        return true;
      }
    })
  );
  return config;
};

export const CARDS_CONFIG = {
  1: getFocusCardConfig,
  2: getAnalyticsCardConfig,
  3: getProfilesCardConfig,
  5: getWorkCardConfig,
};

export const getConfigByAppId = (id: number, translate: TranslateService, card?: ICard): ICardConfig => {
  const configFunc = CARDS_CONFIG[id];
  if (!configFunc) {
    throw new Error(`No config found for app ID: ${id}`);
  }
  return configFunc(card || {} as ICard, translate);
};
